import mergeDeepRight from "ramda/src/mergeDeepRight"

import get from "lodash/get"
import * as ActionTypes from "services/state/action-types"
import { getRepairByStatus } from "./helpers"

const REPAIR_INITIAL_STATE = {
  loading: true,
  loadingDetails: true,
  error: false,
  errorMail: false,
  data: null,
  wizard: {},
  demand: null,
  completed: [],
  progress: [],
  openingOs: {},
  loadingDownloadAndMail: false,
  protocolDetails: {},
  loadingProtocolDetails: false
}

export function repair(state = REPAIR_INITIAL_STATE, action) {
  let payload
  switch (action.type) {
    case ActionTypes.GET_REPAIR:
    case ActionTypes.QUERY_OPEN_REASON:
    case ActionTypes.CREATE_INCIDENT_ORDER:
    case ActionTypes.CREATE_ODIN_INCIDENT_ORDER:
    case ActionTypes.GET_TECHNICIAN:
      return { ...state, loading: true }

    case ActionTypes.GET_REPAIR_BY_PROTOCOL:
    case ActionTypes.SEND_MAIL_REQUEST_DETAIL:
    case ActionTypes.DOWNLOAD_REQUEST_DETAIL:
      return { ...state, loading: true, loadingDownloadAndMail: true }

    case ActionTypes.GET_REPAIR_SUCCESS:
    case ActionTypes.GET_REPAIR_BY_PROTOCOL_SUCCESS:
      payload = action.payload.data
      return {
        ...state,
        loading: false,
        data: payload,
        error: false,
        progress: getRepairByStatus(payload, "PROGRESS"),
        completed: getRepairByStatus(payload, "COMPLETED")
      }
    case ActionTypes.SEND_MAIL_REQUEST_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
        errorMail: true,
        loadingDownloadAndMail: false
      }

    case ActionTypes.GET_REPAIR_FAIL:
    case ActionTypes.GET_REPAIR_BY_PROTOCOL_FAIL:
    case ActionTypes.GET_SERVICE_ORDER_FAIL:
    case ActionTypes.DOWNLOAD_REQUEST_DETAIL_FAIL:
    case ActionTypes.CREATE_INCIDENT_ORDER_FAIL:
    case ActionTypes.CREATE_ODIN_INCIDENT_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        loadingDownloadAndMail: false
      }

    case ActionTypes.QUERY_OPEN_REASON_FAIL:
      return {
        ...state,
        error: true,
        loading: false,
        openingOs: get(
          action.error,
          "response.data.resultData.serviceState",
          {}
        )
      }

    case ActionTypes.SELECT_INCIDENT_PRODUCT:
      return mergeDeepRight(state, { wizard: { product: action.payload } })

    case ActionTypes.GET_INCIDENT_PRODUCT_DETAIL_SUCCESS:
      return mergeDeepRight(state, {
        loading: false,
        wizard: { detail: action.payload }
      })

    case ActionTypes.QUERY_OPEN_REASON_SUCCESS:
      return mergeDeepRight(state, {
        loading: false,
        wizard: { reasons: [] },
        openingOs: get(action.payload, "serviceState", {})
      })

    case ActionTypes.SELECT_INCIDENT_REASON:
      return mergeDeepRight(state, { wizard: { reason: action.payload } })

    case ActionTypes.DOWNLOAD_REQUEST_DETAIL_SUCCESS:
    case ActionTypes.SEND_MAIL_REQUEST_DETAIL_SUCCESS:
      return { ...state, loading: false, loadingDownloadAndMail: false }

    case ActionTypes.GET_SERVICE_ORDER_SUCCESS:
      return {
        ...state,
        loadingDetails: false,
        loading: false,
        demand: action.payload.Stage
      }

    case ActionTypes.CREATE_INCIDENT_ORDER_SUCCESS:
      return mergeDeepRight(state, {
        loading: false,
        wizard: { protocol: action.payload.protocolNumber }
      })

    case ActionTypes.CREATE_ODIN_INCIDENT_ORDER_SUCCESS:
      return mergeDeepRight(state, {
        loading: false,
        wizard: { protocol: action.payload.data.protocolNumber }
      })

    case ActionTypes.CLEAN_WIZARD:
      return { ...state, wizard: {} }

    case ActionTypes.PROTOCOL_DETAILS:
      return { ...state, loadingProtocolDetails: true }

    case ActionTypes.PROTOCOL_DETAILS_SUCCESS: {
      return {
        ...state,
        loadingProtocolDetails: false,
        protocolDetails: action.payload
      }
    }

    case ActionTypes.PROTOCOL_DETAILS_FAIL: {
      return {
        ...state,
        loadingProtocolDetails: false,
        protocolDetails: action.error
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/services/state/repair/reducer.js